import { useLocation, Navigate, Outlet } from "react-router-dom";
import useAuth from "../../hooks/useAuth";

const RequireAuth = ({ allowedRoles, requiredPermissions }) => {
  const { auth } = useAuth();
  const location = useLocation();

  // Role check
  const hasRole = allowedRoles?.includes(auth?.role) && auth?.accessToken;
  if (!hasRole) {
    return <Navigate to="/" state={{ from: location }} replace={false} />;
  }

  // Admin bypasses permission checks
  if (auth?.role === "Admin") return <Outlet />;

  // Permission check (if specified)
  if (requiredPermissions && requiredPermissions.length > 0) {
    const userPerms = auth?.permissions || [];
    const hasPermission = requiredPermissions.some((p) => userPerms.includes(p));
    if (!hasPermission) {
      return <Navigate to="/" state={{ from: location }} replace={false} />;
    }
  }

  return <Outlet />;
};

export default RequireAuth;
